export type { TestTaskEmbeddedPageProps } from './TestTaskEmbeddedPage';
export { default as TestTaskEmbeddedPage } from './TestTaskEmbeddedPage';
